import type { FormatTimeOptions, TimeUnitId } from "@akina/infra";

export const getTimeUnitId = ({ seconds = 0, minutes = 0, hours = 0 }: FormatTimeOptions): TimeUnitId => {
  let unitId: TimeUnitId = "shared.units.seconds";

  const totalTimeInSeconds = seconds + minutes * 60 + hours * 3600;

  if (totalTimeInSeconds >= 60) {
    unitId = "shared.units.minutes";
  }

  if (totalTimeInSeconds >= 3600) {
    unitId = "shared.units.hours";
  }

  return unitId;
};
